<template>
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2H1C0.447715 2 0 1.55228 0 1ZM0 7C0 7.55228 0.447715 8 1 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6H1C0.447715 6 0 6.44772 0 7ZM0 13C0 13.5523 0.447715 14 1 14H15C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12H1C0.447715 12 0 12.4477 0 13Z"
      fill="#868D9C"
    />
  </svg>
</template>
